import React, { useEffect, useState, useContext } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { Routes } from ".";
import { useParams } from "react-router-dom";
interface DataChartProps {
  pending: number;
  inTranshipment: number;
  base: number;
  returningBase: number;
}

export const ChartPie = ({ data }: Routes) => {
  const { getSizesComponent, componentProperty, generateRedirectUrl } =
    useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(300);
  const [widthChart, setWidthChart] = useState(300);
  const [total, setTotal] = useState<number>(0);
  const { mode } = useParams();
  const labels = ["Pendentes", "Em Trânsito", "Retornando para Base", "Base"];

  const dataChart: DataChartProps = {
    base: data?.routes.filter((route: { status_route_id: number }) =>
      [6, 10].some((i) => [route.status_route_id].includes(i))
    ).length,
    inTranshipment: data?.routes.filter((route: { status_route_id: number }) =>
      [2, 3, 4, 7, 8, 9].some((i) => [route.status_route_id].includes(i))
    ).length,
    pending: data?.routes.filter((route: { status_route_id: number }) =>
      [0, 1].some((i) => [route.status_route_id].includes(i))
    ).length,
    returningBase: data?.routes.filter((route: { status_route_id: number }) =>
      [5].some((i) => [route.status_route_id].includes(i))
    ).length,
  };

  useEffect(() => {
    setTotal(
      dataChart.base +
        dataChart.inTranshipment +
        dataChart.pending +
        dataChart.returningBase
    );
  }, [dataChart]);

  const getPositionLegend = (
    width: number,
    height: number
  ): "right" | "bottom" => {
    if (width < 250 || height / width > 1.5) {
      return "bottom";
    } else {
      return "right";
    }
  };

  const options: ApexOptions = {
    chart: {
      animations: {
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
        enabled: false,
      },
      type: "pie",
      events: {
        dataPointSelection: async (event, chartContext, config) => {
          let status = "";
          switch (labels[config.dataPointIndex]) {
            case "Pendentes":
              status = "0,1";
              break;
            case "Em Trânsito":
              status = "2,3,4,7,8,9";
              break;
            case "Retornando para Base":
              status = "5";
              break;
            case "Base":
              status = "6,10";
              break;
          }
          if (
            mode === "view" &&
            componentProperty({
              id: "chartRoutes",
              property: "redirect",
            })
          ) {
            window.open(
              await generateRedirectUrl("chartRoutes", {
                redirectTowerToRoutes: true,
                date: true,
                dueRouteDate: 'dateR',
                status_route_id: status
              }),
              "_blank"
            );
          }
        },
      },
    },
    stroke: {
      colors: undefined,
    },
    labels: labels,
    colors: ["#B1BCBE", "#FFC125", "#FF8118", "#01b8aa"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
          },
        },
      },
    ],
    legend: {
      position: getPositionLegend(widthChart, heightChart),
    },
  };

  const series = [
    dataChart.pending,
    dataChart.inTranshipment,
    dataChart.returningBase,
    dataChart.base,
  ];

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-routes" });
    if (sizes.width < 250) {
      setHeightChart(sizes.height - 30);
    } else {
      setHeightChart(sizes.height - 0.2 * sizes.height);
    }
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, []);

  return completeRequisition ? (
    <div className="h100 component-height">
      <HeaderComponent
        title={`Rotas: Você tem ${total} rotas hoje`}
        clickable={componentProperty({
          id: "chartRoutes",
          property: "redirect",
        })}
        id="chart-routes"
      />
      <div id="chart" className="component-content">
        <Chart
          type="pie"
          options={options}
          series={series}
          height={heightChart}
          width={widthChart}
        />
      </div>
    </div>
  ) : (
    <LoadingGraphics />
  );
};
